import { parseExpr } from "./parser";
function transformCallExpr(name, values) {
    return {
        kind: "CallExpr",
        expr: {
            kind: "CallableExprReference",
            name: name,
        },
        funcArguments: values.map(function (v) {
            if (!v || typeof v !== "object") {
                return parseExpr("" + v);
            }
            var top = Object.keys(v)[0];
            return transformers[top](v[top]);
        }),
    };
}
var transformers = {
    literal: function (value) {
        return {
            kind: "LiteralExpr",
            text: "" + value,
        };
    },
    values: function (values) {
        return transformCallExpr("values", values);
    },
    and: function (values) {
        return transformCallExpr("and", values);
    },
    or: function (values) {
        return transformCallExpr("or", values);
    },
    not: function (values) {
        return transformCallExpr("not", values);
    },
    eq: function (values) {
        return transformCallExpr("eq", values);
    },
    lt: function (values) {
        return transformCallExpr("lt", values);
    },
    gt: function (values) {
        return transformCallExpr("gt", values);
    },
    max: function (values) {
        return transformCallExpr("max", values);
    },
    min: function (values) {
        return transformCallExpr("min", values);
    },
    contains: function (values) {
        return transformCallExpr("contains", values);
    },
    add: function (values) {
        return transformCallExpr("add", values);
    },
    substract: function (values) {
        return transformCallExpr("substract", values);
    },
    mul: function (values) {
        return transformCallExpr("mul", values);
    },
    div: function (values) {
        return transformCallExpr("div", values);
    },
    get: function (values) {
        return transformCallExpr("get", values);
    },
    formatDate: function (values) {
        return transformCallExpr("formatDate", values);
    },
    formatToTimestamp: function (values) {
        return transformCallExpr("formatToTimestamp", values);
    },
};
export function treeToAST(tree) {
    var statements = [];
    var top = Object.keys(tree)[0];
    statements.push(transformers[top](tree[top]));
    return {
        kind: "Program",
        statements: statements,
    };
}
